import type { JSX } from 'react';
import type { UseFormReturn } from 'react-hook-form';

import { Textarea } from '~/components/Field';

import type { OnboardingFormData } from './schemas';

interface OrgOptionalStepProps {
  form: UseFormReturn<OnboardingFormData>;
}

const MAX_DESCRIPTION_LENGTH = 1000;

export function OrganizationDescription({ form }: OrgOptionalStepProps): JSX.Element {
  const {
    formState: { errors },
    register,
    watch,
  } = form;

  const description = watch('description') ?? '';
  const charCount = description.length;

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold mb-2">Organization Description</h2>
        <p className="text-sm">
          Add a description to help team members understand your organization's purpose. This step
          is optional.
        </p>
      </div>

      <div className="relative">
        <Textarea
          id="description"
          label="Description"
          placeholder="Describe what your organization does..."
          isInvalid={!!errors.description}
          errorMessage={errors.description?.message}
          maxLength={1000}
          {...register('description')}
        />
        <div className="text-xs text-right mt-1">
          {charCount}/{MAX_DESCRIPTION_LENGTH}
        </div>
      </div>
    </div>
  );
}
